<template>
  <div class="form">
    <a-form-model ref="form" :model="form" :rules="rules" :colon="false">
      <a-form-model-item label="用户名" prop="name">
        <a-input v-model="form.name" :disabled="true" />
      </a-form-model-item>
      <a-form-model-item label="姓名" prop="userName">
        <a-input v-model="form.userName" :disabled="true" />
      </a-form-model-item>
      <a-form-model-item label="手机号码" prop="mobile">
        <a-input v-model="form.mobile" />
      </a-form-model-item>
      <a-form-model-item label="部门" prop="deptId">
        <a-select
          :disabled="!isHr"
          placeholder=""
          show-search
          :filter-option="$selectFilterOption"
          style="width: 100%"
          v-model="form.deptId"
        >
          <a-select-option
            v-for="item in organizationList"
            :key="item.id"
            :value="item.id"
            >{{ item.uniqueName }}</a-select-option
          >
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="邮箱" prop="email">
        <a-input v-model="form.email" />
      </a-form-model-item>

      <a-form-model-item label="签名图片">
        <div>
          <input
            ref="signUpload"
            style="display: none"
            type="file"
            accept="image/*"
            @change="onSignFileChange"
          />
          <a-button
            :loading="signUploading"
            icon="upload"
            @click="$refs.signUpload.click()"
            >{{ signPath ? "重新上传" : "上传签名" }}</a-button
          >
          <a
            v-if="signPath"
            href="#"
            class="danger"
            style="padding-left: 8px"
            @click="removeSign"
            >删除</a
          >
          <img
            v-if="signPreview"
            :src="signPreview"
            style="display: block; width: 100%; margin-top: 8px"
          />
        </div>
      </a-form-model-item>

      <a-form-model-item label="备注" prop="remarks">
        <a-textarea :auto-size="{ minRows: 3 }" v-model="form.remarks" />
      </a-form-model-item>

      <a-button type="primary" :loading="loading" @click="save"
        >更新基本信息</a-button
      >
    </a-form-model>
  </div>
</template>

<script>
import organization from "@/mixins/organization";
import { mapMutations, mapState, mapGetters } from "vuex";
import { fetchDetail, editBaseInfo, uploadSignFile } from "@/api/setting/user";
export default {
  mixins: [organization],

  data() {
    return {
      loading: false,
      rules: {
        name: [{ required: true, message: "请输入", trigger: "blur" }],
        userName: [{ required: true, message: "请输入", trigger: "blur" }],
        mobile: [{ required: true, message: "请输入", trigger: "blur" }],
        deptId: [{ required: true, message: "请输入", trigger: "blur" }],
        email: [{ required: true, message: "请输入", trigger: "blur" }],
        remarks: [{ required: false }],
      },
      form: {},

      signPath: "", // 签名相对路径，保存到 sign 字段
      signPreview: "", // 签名预览地址（完整路径）
      signUploading: false,
    };
  },
  computed: {
    ...mapState("auth", ["user"]),
    ...mapGetters("auth", ["isHr"]),
  },

  mounted() {
    this.getDetail();
  },
  methods: {
    ...mapMutations("auth", ["setUser"]),

    getDetail() {
      fetchDetail({
        uuid: this.user.uuid,
      }).then((res) => {
        if (res.uuid) {
          this.setUser(res);
          this.signPath = res.sign || "";
          this.signPreview = res.signCompletePath || "";
          this.form = {
            ...res,
            deptId: res.employeeVo ? res.employeeVo.deptId : null,
          };
        }
      });
    },

    onSignFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      const data = new FormData();
      data.append("file", file);
      this.signUploading = true;
      uploadSignFile(data)
        .then((res) => {
          this.signPath = res;
          this.signPreview = URL.createObjectURL(file);
        })
        .finally(() => {
          this.signUploading = false;
          e.target.value = null;
        });
    },

    removeSign() {
      this.signPath = "";
      this.signPreview = "";
    },

    save() {
      this.loading = true;
      this.$refs.form.validate((valid) => {
        if (valid) {
          editBaseInfo({
            ...this.form,
            // 空字符串表示删除签名；不能传 undefined，否则字段被忽略，后端 selective 更新会跳过
            sign: this.signPath || "",
          })
            .then(() => {
              this.loading = false;
              this.getDetail();
            })
            .catch(() => {
              this.loading = false;
            });
        } else {
          this.loading = false;
          return false;
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.form {
  width: 340px;
  margin-right: 104px;
}
</style>